import { environment } from 'src/environments';
import { AppEnv } from 'src/environments/app-env';

export enum AppConfigEnvironmentEnums {
    development = 'DevelopmentAWS',
    staging = 'Staging',
    production = 'Production',
}

export type AppConfigEnvironment = AppConfigEnvironmentEnums | string;

export const defaultAppConfigEnvironment: AppConfigEnvironment = (() => {
    switch (environment.appEnv) {
        case AppEnv.dev:
            return AppConfigEnvironmentEnums.development;
        case AppEnv.staging:
            return AppConfigEnvironmentEnums.staging;
        default:
            return '';
    }
})();
